import getLockingSystemPricePortions, {
	getLockingSystemMsrpPricePortions,
} from "../utils/getLockingSystemPricePortions"

import {
	DispatchLockingSystemReducer,
	LockingSystemReducerState,
} from "reducers/lockingSystemReducer"
import { LockingSystemComponent } from "@secureo/common/typings/LockingSystem"

type SetUpdatedComponentPayload = Pick<
	LockingSystemReducerState,
	| "componentsByUuid"

	// Price
	| "singleNetPriceCents"
	| "singleGrossPriceCents"
	| "totalNetPriceCents"
	| "totalGrossPriceCents"

	// Msrp price
	| "singleNetMsrpPriceCents"
	| "singleGrossMsrpPriceCents"
	| "totalNetMsrpPriceCents"
	| "totalGrossMsrpPriceCents"
>

export const setUpdatedComponent = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	updatedComponent: LockingSystemComponent,
) => {
	const componentsByUuid = {
		...reducerState.componentsByUuid,
		[updatedComponent.uuid]: updatedComponent,
	}

	const { singleNetPriceCents, singleGrossPriceCents, totalNetPriceCents, totalGrossPriceCents } =
		getLockingSystemPricePortions(componentsByUuid, reducerState.quantity)

	const {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	} = getLockingSystemMsrpPricePortions(componentsByUuid, reducerState.quantity)

	const payload: SetUpdatedComponentPayload = {
		componentsByUuid,
		singleNetPriceCents,
		singleGrossPriceCents,
		totalNetPriceCents,
		totalGrossPriceCents,
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}

	dispatch({
		type: "SET_UPDATED_COMPONENT",
		payload,
	})
}
